import { createContext, useContext, useCallback } from 'react';
import useApiService from './ApiService';
import CONFIG from './CONFIG';

const MarkerApiContext = createContext(null);

export function MarkerApiProvider({ children }) {
  const { get, post, put, del } = useApiService(CONFIG.SERVER_ASSISTANT);

  const getMarkers = useCallback(
    async (skip, limit) => {
      if (!skip) {
        skip = 0;
      }
      if (!limit) {
        limit = 10;
      }
      try {
        const response = await get(`/v1/markers?skip=${skip}&limit=${limit}`);
        return response.data;
      } catch (error) {
        console.error('Error fetching markers:', error);
        throw error;
      }
    },
    [get],
  );

  const getMarkerById = useCallback(
    async (markerId) => {
      try {
        const response = await get(`/v1/markers/${markerId}`);
        return response.data;
      } catch (error) {
        console.error('Error fetching marker by ID:', error);
        throw error;
      }
    },
    [get],
  );

  const createMarker = useCallback(
    async (data) => {
      try {
        const response = await put(`/v1/markers`, data);
        return response.data;
      } catch (error) {
        console.error('Error creating marker:', error);
        throw error;
      }
    },
    [put],
  );

  const updateMarker = useCallback(
    async (markerId, data) => {
      try {
        const response = await put(`/v1/markers/${markerId}`, data);
        return response.data;
      } catch (error) {
        console.error('Error updating marker:', error);
        throw error;
      }
    },
    [put],
  );

  const deleteMarker = useCallback(
    async (markerId) => {
      try {
        const response = await del(`/v1/markers/${markerId}`);
        return response.data;
      } catch (error) {
        console.error('Error deleting marker:', error);
        throw error;
      }
    },
    [del],
  );

  return (
    <MarkerApiContext.Provider
      value={{
        getMarkers,
        getMarkerById,
        createMarker,
        updateMarker,
        deleteMarker,
      }}
    >
      {children}
    </MarkerApiContext.Provider>
  );
}

export function useMarkerApi() {
  const context = useContext(MarkerApiContext);
  if (!context) {
    throw new Error('useMarkerApi must be used within a MarkerApiProvider');
  }
  return context;
}
